{
  "enum": {
    "IxcTradeV1TradeStatus": {
      "MATCHED": "Matched",
      "NETTED": "Netted",
      "NETTING": "Netting",
      "ROUTE_ONLY": "Route Only",
      "UNSPECIFIED": "Unspecified",
      "UTC_ONLY": "UTC Only"
    }
  },
  "filterEnum": {
    "IxcTradeV1TradeQueryServiceTradeListFilterableFields": {
      "executionId": "Execution ID",
      "status": "Status",
      "tradeId": "Trade"
    }
  },
  "oneOf": {
    "IxcTradeV1TradeEventType": {
      "enterNetting": "Enter Netting",
      "exitNetting": "Exit Netting",
      "firmRouteExecution": "Firm Route Execution",
      "routeExecution": "Route Execution",
      "utcmessage": "UTC Message"
    }
  },
  "sortEnum": {
    "IxcTradeV1TradeQueryServiceTradeListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}